// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popper-shareable-link{font-size:12px;min-width:300px;padding:0}.popper-shareable-link .header{color:#666e75;padding:.5em}.popper-shareable-link .header .icon{color:#9b0b54}.popper-shareable-link input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#f0f0f0;border:none;display:block;font-family:\"Consolas\",monospace;font-size:12px;outline:none;padding:.5em;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
